import { formatUserName } from "@/utils/users";

export type PostHogOrganizationProperties = {
	id?: string;
	name?: string;
};

export type PostHogPersonProperties = {
	email?: string;
	name?: string;
	organization?: PostHogOrganizationProperties;
};

export function buildPostHogPersonProperties({
	email,
	familyName,
	givenName,
	organizationId,
	organizationName,
}: {
	email?: null | string;
	familyName?: null | string;
	givenName?: null | string;
	organizationId?: null | string;
	organizationName?: null | string;
}): PostHogPersonProperties {
	const name = formatUserName(givenName, familyName);
	const organization: PostHogOrganizationProperties = {
		...(organizationId ? { id: organizationId } : {}),
		...(organizationName ? { name: organizationName } : {}),
	};

	return {
		...(email ? { email } : {}),
		...(name ? { name } : {}),
		...(Object.keys(organization).length > 0 ? { organization } : {}),
	};
}
